import styled from "styled-components";

const StyledMainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
`;

export default StyledMainContainer;
